import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import {
  SITE_MASTER_COLORS,
  StSiteMasterSection,
  StSiteMasterSectionTitle,
  StSiteMasterStack,
} from 'components/SiteMaster/SiteMaster.styles';
import { parseOperatingHours, useSiteMasterRouteFields } from 'components/SiteMaster/utils';
import { Typography } from '@mui/material';

type SiteOperatingHoursProps = ComponentProps & {
  fields: {
    sectionTitle?: Field<string>;
    closedTextColor?: Field<string>;
  };
};

const SiteOperatingHours = (props: SiteOperatingHoursProps): JSX.Element => {
  const routeFields = useSiteMasterRouteFields();
  const hours = parseOperatingHours(routeFields.siteOperatingHours?.value as string | undefined);
  const closedLabel = props.fields.closedTextColor?.value || 'Closed';
  if (!hours.length) {
    return <></>;
  }

  return (
    <StSiteMasterSection id="site-operating-hours">
      <StSiteMasterSectionTitle>
        <Text field={props.fields.sectionTitle} />
      </StSiteMasterSectionTitle>

      <StSiteMasterStack>
        {hours.map((entry) => {
          const isClosed =
            !entry.hours ||
            entry.hours.toLocaleLowerCase() === 'closed' ||
            entry.hours === closedLabel;

          return (
            <div
              key={entry.day}
              style={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 600,
                  padding: '4px 0',
                  color: SITE_MASTER_COLORS.textSecondary,
                  lineHeight: '100%',
                }}
              >
                {entry.day}
              </Typography>

              <Typography
                sx={{
                  fontSize: '14px',
                  lineHeight: '100%',
                  color: isClosed ? SITE_MASTER_COLORS.closed : SITE_MASTER_COLORS.textPrimary,
                }}
              >
                {isClosed ? closedLabel : entry.hours}
              </Typography>
            </div>
          );
        })}
      </StSiteMasterStack>
    </StSiteMasterSection>
  );
};

export default SiteOperatingHours;
